import { Button } from '@material-ui/core';
import React, { useState, useEffect} from "react";
import { Nav } from '../Navbar/NavbarElements';
import Marquee from "react-fast-marquee";


import './CovidBar.css';

function CovidBar() {

    

    
    

    return (
        <div >
            <Marquee className='MWrapper' speed="35"  gradientColor='128, 128, 128'  >
                <p>
                    COVID SAFETY RULES:
                </p>
                <p>
                    <li>
                    Make sure it covers both your nose, mouth and chin. 
                    </li>
                   
                </p>
                {/* <span>  </span> */}
                <p>
                    <li>
                    When you take off a mask, store it in a clean plastic bag, and every day either wash it if it’s a fabric mask, or dispose of a medical mask in a trash bin.
                    </li>
                    
                </p>
                <p>
                    <li>
                    Clean your hands before you put your mask on, as well as before and after you take it off, and after you touch it at any time.
                    </li>
                </p>
            </Marquee>
            
            
        </div>
    )
}

export default CovidBar 
